export const lastTransactions = (state) => state.lastTransactions;

export const payoutAmount = (state) => state.payoutAmount;
